/**
 * License Challenge.
 *
 * @group DRM
 *
 * @beta
 */
export const CHALLENGE = 'Challenge';
